import Cookie from "js-cookie";
const USESCOPE = "USESCOPE";

export default {
  data() {
    return {
      // 排序方式
      orderSort: "$2",
    };
  },
  methods: {
    // 构造query参数
    constructQuery(queryObj) {
      // debugger;
      const defaultParam = {
        // 是否校本
        isSchoolBased: false,
        // 教材目录
        isCatalog: false,
        // 知识点目录
        isKnowlegdeCatalog: false,
        // 同步备考目录
        isExamCatalog: false,
        // 高考复习目录
        isReviewCatalog: false,
        // 试卷目录
        isPaperCatalog: false,
        // 类别
        isCategory: false,
        // 场景
        isScene: false,
        // 范围
        isRange: false,
        // 排序
        isOrder: false,
        // 文档类型
        isFileType: false,
        // 隐藏框
        // isFilteDropdown: false,
        // 地区
        isArea: false,
        // 搜索词
        isKeywords: false,
        // 试题试卷的特殊选项
        isOption: false,
        // 年级
        isGrade: false,
        // 学期
        isTerm: false,
        // 学年
        isYearRange: false,
        // 更新状态
        isUpdateStatus: false,
        // 学校等级
        isSchoolLevel: false,
        // 是否选择了子类型
        isSubType: false,
        // 等级
        isClass: false,
        // 实操实验目录
        isScsyCatalog: false,
        // 学科特色
        isSubjectCharacteristic: false,
        // 学科特色筛选
        // isSubjectCharacteristicFilter:false,
        isTeachResearch: false,
        // 一轮复习下的子节点
        isScenarioKpoints: false,
        // 云资源tab
        isTab: false,
        isExperimentForm: false,
        isParentSubjectFeatures: false,
        // 覆盖考试范围
        isExamScope: false,
        // ai学科
        isSciCatalog: false,
        // ai阅读
        isAiReadCatalog: false,
        isSchool: false,
        // 系列
        isSeries: false,
        // 教材版本
        isVersion: false,
      };
      const initParam = Object.assign(defaultParam, queryObj || {});
      // console.log("initParam", initParam);
      let query = {};
      // 教材目录的选中
      if (initParam.isCatalog) {
        this.currentTreeNode && (query.parentCatalogIds = this.currentTreeNode);
      }
      if (initParam.isSciCatalog) {
        this.currentTreeNode && (query.parentTreeId = this.currentTreeNode);
      }
      if (initParam.isVersion) {
        this.currentTextBookVersion &&
          (query.versionId = this.currentTextBookVersion);
      }
      // 知识点目录的选中
      if (initParam.isKnowlegdeCatalog) {
        if (this.currentKPointTreeNode) {
          if (typeof this.currentKPointTreeNode == "object") {
            this.currentKPointTreeNode.id
              ? (query.parentKPointId = this.currentKPointTreeNode.id)
              : null;
          } else {
            query.parentKPointId = this.currentKPointTreeNode;
          }
        } else if (this.currentTreeNode) {
          query.parentKPointId = this.currentTreeNode;
        }
        // (query.parentKPointId =
        //  typeof this.currentKPointTreeNode  == 'object' ?  this.currentKPointTreeNode.id ? this.currentKPointTreeNode);
      }
      // console.log("currentTreeNode", this.currentTreeNode);
      if (initParam.isScsyCatalog) {
        this.currentTreeNode &&
          (query.parentSubjectFeatures = this.currentTreeNode);
        // this.currentExperimentCategory &&
        //   (query.subjectFeatureType = this.currentExperimentCategory);
      }
      // console.log('query',query)
      //
      // 同步备课目录的选中
      if (initParam.isExamCatalog) {
        // console.log("his.currentTreeNode", this.currentTreeNode);
        this.currentTreeNode &&
          (this.$route.path.indexOf("/lab") > -1
            ? (query.parentSubjectFeatures = this.currentTreeNode)
            : (query.parentScenarioId = this.currentTreeNode));
      }
      // 高考复习的目录选中
      // if (initParam.isReviewCatalog) {
      //   this.currentTreeNode && (query.parentScenarioId = this.currentTreeNode);
      // }
      // 试卷目录的选中
      if (initParam.isPaperCatalog) {
        this.currentTreeNode && (query.parentScenarioId = this.currentTreeNode);
      }
      if (initParam.isSeries) {
        this.currentTreeNode && (query.seriesId = this.currentTreeNode);
      }
      // console.log('this.currentTreeNode1',this.currentTreeNode)
      // 类别的选中
      if (initParam.isCategory) {
        if (initParam.isSchoolBased) {
          this.currentCategory && (query.parentTypeIds = this.currentCategory);
        } else {
          // console.log("this.currentCategory", this.currentCategory);
          // console.log("this.currentSubCategory", this.currentSubCategory);
          this.currentCategory && (query.parentTypeId = this.currentCategory);
          this.currentSubCategory &&
            (query.parentTypeId = this.currentSubCategory);
        }
      }
      // 子类型的选中
      if (initParam.isSubType) {
        this.currentSubType && (query.parentTypeId = this.currentSubType);
      }
      // 学期的选中
      if (initParam.isTerm) {
        let path = this.$route.path;
        if (path.indexOf("/zyk/juemi") > -1) {
          query.termId = this.termList[this.termIndex].id;
        } else {
          this.currentTerm && (query.term = this.currentTerm);
        }
      }
      // tab选择
      if (initParam.isTab) {
        this.currentTabId && (query.tabId = this.currentTabId);
      }
      // 年级的选中
      if (initParam.isGrade) {
        let path = this.$route.path;

        if (path.indexOf("/zyk/juemi") == -1) {
          if (initParam.isSchoolBased) {
            this.currentGrade && (query.gradeIds = [this.currentGrade]);
          } else {
            this.currentGrade &&
              (!initParam.isAiReadCatalog
                ? (query.gradeIds = this.currentGrade)
                : (query.gradeId = this.currentGrade));
          }
        } else {
          query.gradeId = this.gradeList[this.gradeIndex].id;
        }
      }
      // 场景的选中
      if (initParam.isScene) {
        this.currentScene && (query.parentScenarioId = this.currentScene);
      }
      // 地区的选中
      if (initParam.isArea) {
        this.currentArea && (query.parentAreaIds = this.currentArea);
        if (this.$route.path.indexOf("/mingxiao") == -1) {
          this.$route.query.schoolId &&
            (query.schoolId = this.$route.query.schoolId);
        }
      }
      if (initParam.isSchool) {
        this.currentSchool && (query.schoolId = this.currentSchool);
      }
      // 年份的选中
      if (initParam.isYear) {
        this.currentYear && (query.year = this.currentYear);
      }
      if (initParam.isClass) {
        this.currentClass && (query.commercialLevel = this.currentClass);
      }
      if (initParam.isScenarioKpoints) {
        this.currentTreeNode &&
          (query.parentScenarioKpoints = this.currentTreeNode);
      }
      // console.log("当前节点", initParam.isSubjectCharacteristic);
      // 学科特色的选中
      if (initParam.isSubjectCharacteristic) {
        // console.log("学科特色");
        this.currentSubjectCharacteristic &&
          (query.subjectFeatureType = this.currentSubjectCharacteristic);
        this.currentTreeNode &&
          (query.subjectFeatureType = this.currentTreeNode);
      }
      if (initParam.isExperimentForm) {
        this.currentExperimentForm &&
          (query.experimentForm = this.currentExperimentForm);
      }
      // if(initParam.isExamScope){
      //   console.log('currentExamScope',this.currentExamScope)
      //   this.currentExamScope && (query.examScope = this.currentExamScope)
      // }
      if (initParam.isParentSubjectFeatures) {
        this.currentTreeNode &&
          (query.parentSubjectFeatures = this.currentTreeNode);
      }
      if (initParam.isTeachResearch) {
        this.currentTeachResearch &&
          (query.teachResearch = this.currentTeachResearch);
      }
      // 试题试卷的特殊筛选
      if (initParam.isOption) {
        this.currentOption &&
          Object.keys(this.currentOption).forEach((key) => {
            if (this.currentOption[key]) {
              query[key] = this.currentOption[key];
            }
          });
      }
      // 范围的选中
      if (initParam.isRange) {
        this.currentRange && (query.examScope = this.currentRange);
      }
      // 排序的选中
      if (initParam.isOrder) {
        this.currentOrder &&
          (query.orders = this.currentOrder + this.orderSort);
      }
      // 文档类型选中
      if (initParam.isFileType) {
        this.currentFileType && (query.fileTypeId = this.currentFileType);
      }
      // 地区年份等级的选中
      // if (initParam.isFilteDropdown && this.filterResult.length) {
      //   for (let item of this.filterResult) {
      //     query[item.eName] = item.id;
      //   }
      // }
      // 关键词选中
      if (initParam.isKeywords) {
        this.keywords &&
          (!initParam.isAiReadCatalog
            ? (query.title = this.keywords)
            : (query.keyWord = this.keywords));
      }
      // 学年的选中
      if (initParam.isYearRange) {
        this.currentYearRange && (query.schoolYear = this.currentYearRange);
      }
      if (initParam.isAiReadCatalog) {
        this.currentTreeNode && (query.catalogId = this.currentTreeNode);
      }
      // 更新状态的选中
      if (initParam.isUpdateStatus) {
        this.currentUpdateStatus &&
          (query.updateStatus = this.currentUpdateStatus);
      }
      if (initParam.isSchoolLevel) {
        this.currentSchoolLevel &&
          (query.schoolLevelId = this.currentSchoolLevel);
      }
      if (this.$route.query.courseId) {
        // console.log("有courseI参数");
        query.courseId = this.$route.query.courseId;
      }
      if (this.$route.query.tabId) {
        query.tabId = this.$route.query.tabId;
      }
      if (this.$route.query.pageId) {
        query.pageId = this.$route.query.pageId;
      }
      // if (this)
      if (this.$route.query.redirectType) {
        query.redirectType = this.$route.query.redirectType;
      }

      // console.log('this.currentTreeNode',this.currentTreeNode)
      return query;
    },
    // 拆解路由中的query，选中页面中的筛选项
    async parseRouteQuery(param) {
      let useScope = Cookie.get(USESCOPE);
      const defaultParam = {
        // 教材目录
        isCatalog: true,
        // 知识点目录
        isKnowlegdeCatalog: true,
        // 同步备考目录
        isExamCatalog: true,
        // 高考复习的目录
        isReviewCatalog: true,
        // 类别
        isCategory: true,
        // 场景
        isScene: true,
        // 范围
        isRange: true,
        // 排序
        isOrder: true,
        // 文档类型
        isFileType: true,
        // 隐藏框
        isFilteDropdown: true,
        // 地区
        isArea: true,
        // 等级
        isClass: true,
        // 年份
        isYear: true,
        // 搜索词
        isKeywords: true,
        // 试题试卷的特殊选项
        isOption: true,
        // 年级
        isGrade: true,
        // 学期
        isTerm: true,
        // 学年
        isYearRange: true,
        // 是否选择了子类型
        isSubType: true,
        SubCategory: true,
        // 更新状态
        isUpdateStatus: true,
        // 实操实验目录
        isScsyCatalog: true,
        // 学科特色
        isSubjectCharacteristic: true,
        // 其他筛选项
        isTeachResearch: true,
        // 一轮复习下的子节点
        isScenarioKpoints: true,
        // 教学节点
        isTeach: true,
        // 教学栏目类型id
        isTeachMenuCategory: true,
        // 教学目录
        isTeachCatalog: true,
        // 实验筛选
        isExperimentForm: true,
        // 当前考试覆盖范围
        isExamScope: true,
        // 实验类型目录树
        isParentSubjectFeatures: true,
        isSearchType: true,
        isCourseFilter: true,
        isLabTypeFilter: true,
        isPaperPage: false,
        isSciCatalog: true,
        isSchool: true,
        // 系列
        isSeries: true,
        // 教材版本
        isVersion: true,
      };
      const initParam = Object.assign(defaultParam, param || {});

      const query = this.$route.query;
      // 教材目录的解析
      if (query.parentCatalogIds !== undefined && initParam.isCatalog) {
        this.parseRouteTreeNode(this.catalogs, query.parentCatalogIds);
      }
      if (query.teachId != undefined && initParam.isTeachCatalog) {
        // console.log("this.catalogList,", this.catalogList);
        let treeId = 0;
        if (query.catalogType && query.catalogType == 3) {
          treeId = query.categoryId;
        } else {
          treeId = query.catalogId || query.teachId;
        }
        // let treeId = query.catalogType && query.catalogType == 3 ? query.categoryId : ()
        this.parseRouteTreeNode(this.catalogList, treeId);
      }
      // 知识点目录的解析
      if (query.parentKPointId !== undefined && initParam.isKnowlegdeCatalog) {
        this.currentTabId = 2;
        this.parseRouteTreeNode(this.knowledgeCatalogs, query.parentKPointId);
      }
      // 同步备课目录的解析
      if (
        !query.parentCatalogIds &&
        // query.parentScenarioId !== undefined &&
        // initParam.isExamCatalog
        ((query.parentScenarioId !== undefined && initParam.isExamCatalog) ||
          (query.parentScenarioKpoints != undefined &&
            initParam.isScenarioKpoints))
      ) {
        this.currentTabId = 1;
        // this.parseRouteTreeNode(this.examCatalogs, query.parentScenarioId);
        this.parseRouteTreeNode(
          this.examCatalogs,
          query.parentScenarioId || query.parentScenarioKpoints
        );
      }
      // 实操实验目录的解析
      if (
        query.parentSubjectFeatures !== undefined &&
        initParam.isScsyCatalog
      ) {
        this.parseRouteTreeNode(this.catalogs, query.parentSubjectFeatures);
      }
      if (query.versionId != undefined && initParam.isVersion) {
        this.currentTextBookVersion = query.versionId;
      }
      // 当前实验类型的解析
      if (query.subjectFeatureType != undefined && initParam.isScsyCatalog) {
        this.currentExperimentCategory = query.subjectFeatureType;
        this.currentTreeNode = query.subjectFeatureType;
      }
      if (query.experimentForm != undefined && initParam.isExperimentForm) {
        this.currentExperimentForm = query.experimentForm;
        //  console.log('currentExperimentForm',this.currentExperimentForm)
      }
      if (query.examScope != undefined && initParam.isExamScope) {
        // console.log("query.examScope", query.examScope);
        this.currentExamScope = query.examScope;
      }
      if (
        query.parentSubjectFeatures != undefined &&
        initParam.isParentSubjectFeatures
      ) {
        // console.log("isParentSubjectFeatures--");
        this.currentTreeNode = query.parentSubjectFeatures;
      }
      if (query.parentTreeId != undefined && initParam.isSciCatalog) {
        this.currentTreeNode = query.parentTreeId;
      }
      if (query.seriesId != undefined && initParam.isSeries) {
        this.currentTreeNode = query.seriesId;
      }
      if (query.pageId != undefined && initParam.isSciCatalog) {
        this.pageId = query.pageId;
      }
      // console.log("currentTreeNode----", this.currentTreeNode);
      // 高考复习的目录
      // console.log("initParam.isReviewCatalog", initParam.isReviewCatalog);
      if (
        !query.parentCatalogIds &&
        query.parentScenarioId !== undefined &&
        initParam.isReviewCatalog
      ) {
        // this.currentTabId = 1;
        this.parseRouteTreeNode(this.reviewCatalogs, query.parentScenarioId);
      }
      // 类别的解析
      if (initParam.isCategory) {
        if (initParam.isSchoolBased) {
          this.currentCategory = query.parentTypeIds || query.typeId || "";
        } else {
          if (query.parentTypeId && query.parentTypeId.startsWith("3106")) {
            this.currentCategory = "3106";
          } else {
            // 判断如果类型大于四位那就是子类型
            // let currentSubCategory = '';
            // let currentCategory = '';
            // query.parentTypeId.length > 4 ? parentTypeId
            if (query.parentTypeId && query.parentTypeId.length > 4) {
              this.currentSubCategory = initParam.SubCategory
                ? query.parentTypeId
                : null;
              this.currentCategory = initParam.SubCategory
                ? query.parentTypeId.slice(0, 4)
                : query.parentTypeId;
            } else {
              this.currentSubCategory = "";
              this.currentCategory = query.parentTypeId || "";
            }
            // console.log("this.resourceCategories", this.resourceCategories);
            this.resourceSubCategories =
              (this.resourceCategories &&
                this.resourceCategories.length > 0 &&
                this.resourceCategories.find(
                  (item) => item.strNodeId == this.currentCategory
                ).navFilterChildNode) ||
              [];

            // query.parentTypeId.length > 4 ?  (this.currentSubCategory = query.parentTypeId || '') :  (this.currentCategory = query.parentTypeId || '')
            // query.parentTypeId.length > 4 ? this.resourceSubCategories = this.resourceCategories.find(item => item.strNodeId == query.parentTypeId)
            // this.currentCategory = query.parentTypeId || "";
          }
        }
      }
      // 子类型的选中
      if (initParam.isSubType) {
        this.currentSubType =
          query.parentTypeId === "3106" ? "" : query.parentTypeId;
      }

      // 年级的解析
      if (initParam.isGrade) {
        if (initParam.isSchoolBased) {
          if (query.gradeIds || query.gradeId) {
            this.currentGrade = query.gradeIds || query.gradeId || [];
            if (this.currentGrade && this.currentGrade.length > 0) {
              this.currentGrade = parseInt(this.currentGrade);
            } else {
              this.currentGrade = query.gradeIds || query.gradeId || [];
            }
          } else {
            // if (useScope) {
            //   let useScopeArr = useScope.split("|");
            //   let [year, term, grade] = useScopeArr;
            //   this.currentGrade = parseInt(grade) ? parseInt(grade) : "";
            // }
          }
        } else {
          this.currentGrade =
            Number(query.gradeIds) || Number(query.gradeId) || "";
        }
      }
      // 学期的反选
      if (initParam.isTerm) {
        if (query.term) {
          this.currentTerm = query.term || "";
        } else {
          if (useScope) {
            let useScopeArr = useScope.split("|");
            let [year, term, grade] = useScopeArr;
            this.currentTerm = term || "";
          }
        }
        // let path = this.$route.path;
        // if (path.indexOf("/zyk/juemi") > -1) {

        // }
      }

      // 学年的解析
      if (initParam.isYearRange) {
        if (query.schoolYear) {
          this.currentYearRange = query.schoolYear || "";
        } else {
          if (useScope) {
            let useScopeArr = useScope.split("|");
            let [year, term, grade] = useScopeArr;
            this.currentYearRange = year || "";
          }
        }
      }
      // 地区的解析
      if (initParam.isArea) {
        this.currentArea = query.parentAreaIds || "";
      }
      // 学校的解析
      if (initParam.isSchool) {
        this.currentSchool = query.schoolId || "";
      }
      if (initParam.isPaperPage && query.parentAreaIds) {
        let isProv =
          query.parentAreaIds.slice(2) == "0000" ||
          query.parentAreaIds.length == 1;
        let provinceId = !isProv
          ? query.parentAreaIds.slice(0, 2) + "0000"
          : query.parentAreaIds;
        this.currentArea = provinceId;
      }
      // 搜索类型解析
      if (initParam.isSearchType) {
        this.pulldowIdentification = query.pulldowIdentification || "1";
      }
      // 学科特色的解析
      if (initParam.isSubjectCharacteristic) {
        this.currentSubjectCharacteristic = query.subjectFeatureType || "";
      }
      if (initParam.isTeachResearch) {
        this.currentTeachResearch = query.teachResearch || "";
      }
      // 试题试卷的特殊解析
      if (initParam.isOption) {
        // 解析试题试卷下的特殊选项
        this.parseRouteOption(query);
      }
      // 排序的解析
      if (initParam.isOrder) {
        // 排序的选中最新/周月日下载
        this.currentOrder =
          (query.orders &&
            (query.orders.indexOf("$2") > -1
              ? query.orders.slice(0, -2)
              : query.orders)) ||
          this.timeType;
        console.log("currentOrder", this.currentOrder);
      }
      // 文档类型解析
      if (initParam.isFileType) {
        // 选中的文档类型
        this.currentFileType = query.fileTypeId;
      }
      // 课程筛选解析
      if (initParam.isCourseFilter) {
        this.currentCourseId = query.courseId;
      }
      // 实验形式筛选
      if (initParam.isLabTypeFilter) {
        this.currentLabType = query.labTypeId;
      }
      // 地区年份等级的解析

      if (initParam.isClass) {
        this.currentClass = query.commercialLevel;
      }
      if (initParam.isYear) {
        this.currentYear = query.year || "";
      }
      // if (initParam.isFilteDropdown) {
      //   this.parseRouteAreaYearClass(query);
      // }
      // 关键词解析
      if (initParam.isKeywords) {
        // 检索关键字
        this.keywords = query.title;
      }
      // 场景的解析
      if (initParam.isScene && !initParam.isSchoolBased) {
        // 获取资源类型下的场景
        // await this.getResourceScene(this.currentCategory);
        // 资料场景选中
        this.currentScene = query.parentScenarioId || "";
      }
      // 范围的解析
      if (initParam.isRange) {
        // 获取场景下的范围列表
        // const sceneId = query.parentScenarioId || this.currentTreeNode;
        // this.getSpecialRange(this.currentCategory, sceneId);
        // 资料范围选中?
        this.currentRange = query.examScope || "";
      }
      // 更新状态的解析
      if (initParam.isUpdateStatus) {
        // console.log(typeof query.status)
        if (
          (typeof query.updateStatus === "string" &&
            query.updateStatus != "") ||
          (typeof query.status === "string" && query.status != "")
        ) {
          this.currentUpdateStatus = query.updateStatus || query.status;
        } else {
          this.currentUpdateStatus = query.updateStatus || query.status || "";
        }
      }
      // console.log("currentUpdateStatus", this.currentUpdateStatus);
      // 解析资料类型
      if (query.softType) {
        this.currentSoftType = parseInt(query.softType);
      }
      if (query.redirectType || query.tabId) {
        this.currentTabId = Number(query.redirectType || query.tabId);
      }
      if (query.areaId) {
        this.currentAreaId = query.areaId;
      }
      if (query.academicYear) {
        this.currentYear = query.academicYear;
      }
      // if(query.monthId){
      this.currentMonth = query.month || "";
      // }
      if (initParam.isTeachMenuCategory) {
        this.currentCategoryId = query.categoryId
          ? parseInt(query.categoryId)
          : 0;
        // console.log("this.currentCategoryId", this.currentCategoryId);
      }
      // 获取页码
      this.pageIndex = parseInt(query.pageIndex) || 1;
      // 获取每页显示的条数
      // this.pageSize = parseInt(query.pageSize) || 30;
    },
    // 解析目录的选中
    parseRouteTreeNode(catalogs, id) {
      this.currentTreeNode = id || "";
      let parentId = 0;
      if (!this.currentTreeNode) return;
      // 找到选中的目的节点
      try {
        this.loopArr(catalogs, (node) => {
          if (node.id.toString() === this.currentTreeNode) {
            this.$set(node, "isShow", true);
            parentId = node.parentId;
            return true;
          }
        });
      } catch (err) {}
      try {
        // 父级都打开
        if (parentId === catalogs.id) return;
        this.loopArr(catalogs, (nodeTree) => {
          if (parentId && parentId === catalogs.id) return true;
          try {
            this.loopArr(catalogs, (node) => {
              if (node.id === parentId) {
                this.$set(node, "isShow", true);
                parentId = node.parentId;
                return true;
              }
            });
          } catch (err) {}
        });
      } catch (err) {}
    },
    // 解析试题试卷下的特殊选项
    async parseRouteOption(query) {
      // 获取试题试卷下的特殊选项
      // await this.getResourceOption(query.parentTypeId, query.subjectId);
      const { paperAnswer, paperExp, paperMedia, attachmentTypes } = query;
      // 选中的筛选
      this.currentOption = {
        paperAnswer,
        paperExp,
        paperMedia,
        attachmentTypes,
      };
    },
    // 解析地区年份等级
    parseRouteAreaYearClass(query) {
      // 查找地区
      let area = null;
      let classData, yearData, areaData;
      if (query.parentAreaIds) {
        areaData = this.filterOptions.find((data) => {
          return data.eName === "parentAreaIds";
        });
        area =
          areaData &&
          areaData.list.find((item) => {
            return item[areaData.idKey] === query.parentAreaIds;
          });
      }
      // 查找年份
      let year = null;
      if (query.year) {
        yearData = this.filterOptions.find((data) => {
          return data.eName === "year";
        });
        year =
          yearData &&
          yearData.list.find((item) => {
            return item[yearData.idKey] === query.year;
          });
      }
      // 查找等级
      let classes = null;
      if (query.commercialLevel) {
        classData = this.filterOptions.find((data) => {
          return data.eName === "commercialLevel";
        });
        classes =
          classData &&
          classData.list.find((item) => {
            return item[classData.idKey] === query.commercialLevel;
          });
      }
      this.filterResult = [];
      if (area) {
        this.filterResult.push({
          id: area[areaData.idKey],
          eName: areaData.eName,
          value: area[areaData.showKey],
        });
        this.filterCount += 1;
        areaData.selected = area;
      }
      if (year) {
        this.filterResult.push({
          id: year[yearData.idKey],
          eName: yearData.eName,
          value: year[yearData.showKey],
        });
        this.filterCount += 1;
        yearData.selected = year;
      }
      if (classes) {
        this.filterResult.push({
          id: classes[classData.idKey],
          eName: classData.eName,
          value: classes[classData.showKey],
        });
        this.filterCount += 1;
        classData.selected = classes;
      }
    },
    loopArr(arr, callBack) {
      for (const item of arr) {
        let isBreak = false;
        callBack && (isBreak = callBack(item));
        if (isBreak) {
          // break;
          throw new Error("eee");
        } else {
          const list = item.childCatalogList;
          list && list.length && this.loopArr(list, callBack);
        }
      }
    },
  },
};
